import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function upsert(selector, create, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
  return el;
}

const meta = (key, isProp, content) =>
  upsert(`meta[${isProp ? 'property' : 'name'}="${key}"]`, () => {
    const m = document.createElement('meta');
    m.setAttribute(isProp ? 'property' : 'name', key);
    return m;
  }, { content: content || '' });

function apply(p) {
  document.title = p.title;
  meta('description', false, p.description);
  meta('robots', false, p.robots);
  upsert('link[rel="canonical"]', () => {
    const l = document.createElement('link');
    l.setAttribute('rel', 'canonical');
    return l;
  }, { href: p.canonical });
  [['og:type', p.og_type], ['og:url', p.canonical], ['og:title', p.title], ['og:description', p.description], ['og:image', p.image]]
    .forEach(([k, v]) => meta(k, true, v));
  [['twitter:title', p.title], ['twitter:description', p.description], ['twitter:image', p.image]]
    .forEach(([k, v]) => meta(k, false, v));
  document.head.querySelectorAll('script[type="application/ld+json"]:not(#seo-jsonld)').forEach((s) => s.remove());
  const ld = upsert('#seo-jsonld', () => {
    const s = document.createElement('script');
    s.id = 'seo-jsonld';
    s.type = 'application/ld+json';
    return s;
  }, {});
  ld.textContent = JSON.stringify(p.jsonld);
}

// Applies the per-route title, meta, canonical, OG/Twitter and JSON-LD from the backend SEO engine.
export default function SeoManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    let alive = true;
    axios.get(`${API}/seo/meta`, { params: { path: pathname } })
      .then(({ data }) => alive && apply(data))
      .catch((err) => alive && err.response?.data?.title && apply(err.response.data));
    return () => { alive = false; };
  }, [pathname]);
  return null;
}
